import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  ButtonGroup,
  Button,
  FormControlLabel,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  Paper,
  Typography,
  Divider,
  Fade,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Swal from "sweetalert2";
import {
  CommonSubHeader,
  useLocationHelpers,
  NavButton,
} from "../../Components/helpers/Helpers";
import api from "../../api/axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SearchIcon } from "lucide-react";

/* ======================================================
   DEFINICIÓN ÚNICA DE MÓDULOS (FUENTE DE VERDAD)
====================================================== */

export const MODULE_DEFINITIONS = {
  core: [
    {
      id: "Contactos",
      backendKey: "contacts",
      permissions: [
        "view",
        "onlyassign",
        "add",
        "edit",
        "delete",
        "deletenotes",
        "assign",
        "notes_all",
        "notes_own",
      ],
    },
    {
      id: "Clientes",
      backendKey: "clients",
      permissions: [
        "view",
        "onlyassign",
        "add",
        "edit",
        "delete",
        "deletenotes",
        "signcontract",
        "signfi",
        "viewfi",
        "notes_all",
        "notes_own",
      ],
    },
    {
      id: "Expedientes",
      backendKey: "cases",
      permissions: [
        "view",
        "onlyassign",
        "add",
        "edit",
        "delete",
        "addnotes",
        "deletenotes",
        "notes_own",
        "notes_all",
        "addalerts",
        "deletealerts",
        "alerts_own",
        "alerts_all",
        "docs",
        "deletedocs",
        "assing",
        "change",
        "signcontract",
        "signfi",
        "viewfi",
      ],
    },
  ],

  configuracion: [
    {
      id: "Empresas",
      backendKey: "company",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Asociaciones",
      backendKey: "association",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Despachos",
      backendKey: "office",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Grupos",
      backendKey: "group",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Usuarios",
      backendKey: "users",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Roles de Usuario",
      backendKey: "userstypes",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Configuración expediente",
      backendKey: "caseconfig",
      permissions: ["view"],
    },
    {
      id: "Tipos de Casos",
      backendKey: "casestypes",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Hojas de encargo/Contratos",
      backendKey: "contracts",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Flujos de casos",
      backendKey: "casesflow",
      permissions: ["view", "add", "edit", "delete"],
    },
  ],

  otros: [
    {
      id: "Plantillas Email Notificaciones",
      backendKey: "templates",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Facturas",
      backendKey: "bills",
      permissions: ["view", "add", "edit", "delete"],
    },
    {
      id: "Estadí­sticas",
      backendKey: "stats",
      permissions: ["view", "add", "edit", "delete", "calls"],
    },
    {
      id: "Biblioteca",
      backendKey: "library",
      permissions: ["view", "add", "edit", "delete"],
    },
  ],
};

/* ======================================================
   ETIQUETAS DE PERMISOS
====================================================== */

export const PERMISSION_LABELS = {
  view: "Ver",
  add: "Añadir",
  edit: "Editar",
  delete: "Eliminar",
  assign: "Cambiar abogado",
  addnotes: "Agregar notas",
  deletenotes: "Eliminar notas",
  addalerts: "Agregar alertas",
  deletealerts: "Eliminar alertas",
  onlyassign: "Ver solo empresa",
  signcontract: "Firmar contrato",
  docs: "Añadir",
  deletedocs: "Eliminar",
  assing: "Asignar usuario",
  change: "Modificar cabecera",
  calls: "Centralita",
  signfi: "Firmar FI",
  viewfi: "Ver",
  notes_own: "Propias",
  notes_all: "Todas",
  alerts_own: "Propias",
  alerts_all: "Todas",
  // calls: "Videollamadas - Deshabilitado",
};

export const EXPEDIENTES_GROUPS = [
  {
    title: "Permisos Básicos",
    permissions: ["view", "onlyassign", "add", "edit", "delete"],
  },
  {
    title: "Configuración general (Apud acta, cambiar estado de expediente...)",
    permissions: ["assing", "change"],
  },
  {
    title: "Contrato",
    permissions: ["signcontract"],
  },
  {
    title: "Notas",
    permissions: ["addnotes", "deletenotes", "notes_own", "notes_all"],
  },
  {
    title: "Alertas",
    permissions: ["addalerts", "deletealerts", "alerts_own", "alerts_all"],
  },
  {
    title: "Documentación",
    permissions: ["docs", "deletedocs"],
  },
  {
    title: "Formulario FI",
    permissions: ["signfi", "viewfi"],
  },
];

export const CLIENTES_GROUPS = [
  {
    title: "Permisos Básicos",
    // permissions: ["view", "add", "edit", "delete", "onlyassign"],
    permissions: ["view", "onlyassign", "add", "edit", "delete"],
  },
  // {
  //   title: "Expedientes",
  //   permissions: ["signcontract"],
  // },
  {
    title: "Notas",
    permissions: ["deletenotes", "notes_own", "notes_all"],
  },
  // {
  //   title: "Documentación",
  //   permissions: ["docs", "deletedocs"],
  // },
  // {
  //   title: "Formulario FI",
  //   permissions: ["signfi", "viewfi"],
  // },
];

export const CONTACTS_GROUPS = [
  {
    title: "Permisos Básicos",
    permissions: ["view", "onlyassign", "add", "edit", "delete"],
    // permissions: ["view", "add", "edit", "delete", "onlyassign"],
  },
  {
    title: "Notas",
    permissions: ["deletenotes", "notes_own", "notes_all"],
  },
];

export const EXCLUSIVE_PERMISSION_GROUPS = {
  notes: ["notes_own", "notes_all"],
  alerts: ["alerts_own", "alerts_all"],
};
export const ACTION_PERMISSION_GROUPS = {
  notes: ["deletenotes"],
  alerts: ["deletealerts"],
};

/* ======================================================
   COMPONENTE
====================================================== */
const Editar = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rolId = searchParams.get("id");
  const { goPanel, goTable, buildTableUrl } = useLocationHelpers();

  const [rolData, setRolData] = useState({ rol: "", user_level: "" });
  const [radioValue, setRadioValue] = useState("");
  const [role, setRole] = useState(null);
  const [checkedState, setCheckedState] = useState({});
  const [flag, setFlag] = useState(false);
  const [searchPermission, setSearchPermission] = useState("");

  const isSuperAdmin = String(rolId) === "1";

  const isCheckboxDisabled = (checked) => false;

  /* ======================================================
     DATA
  ===================================================== */
  const getRole = async () => {
    try {
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/roles/edit?id=${rolId}`,
      );
      setRole(res.data.role);
      setFlag(true);
    } catch {
      Swal.fire("Error", "No autorizado o error servidor", "error").then(() =>
        navigate("/"),
      );
    }
  };

  useEffect(() => {
    getRole();
  }, []);

  // --- USEEFFECT al cargar el rol desde BD ---
  useEffect(() => {
    if (!role?.config) return;

    // Datos básicos del rol
    setRolData({ rol: role.type, user_level: role.user_level });
    const access = String(role.config.access ?? "");
    setRadioValue(access);

    // Construir estado de checkboxes incluyendo permisos nuevos
    const state = {};
    Object.values(MODULE_DEFINITIONS)
      .flat()
      .forEach((mod) => {
        const permsFromDb = role.config[mod.backendKey] || {};
        const childrenChecked = mod.permissions.map((perm, i) => {
          // Mantener estado previo o cargar de la DB, default false
          return (
            checkedState[mod.id]?.childrenChecked[i] ??
            !!permsFromDb[perm] ??
            false
          );
        });
        state[mod.id] = {
          childrenChecked,
          parentChecked: childrenChecked.every(Boolean),
        };
      });

    setCheckedState(state);
  }, [role]);

  // --- USEEFFECT al cambiar el radio ---
  useEffect(() => {
    if (!role) return;

    setCheckedState((prev) => {
      const newState = { ...prev };
      Object.values(MODULE_DEFINITIONS)
        .flat()
        .forEach((mod) => {
          const prevChildren = prev[mod.id]?.childrenChecked || [];

          // Aplica reglas del radio solo sobre permisos "controlados" por radio
          const childrenChecked = mod.permissions.map((perm, i) => {
            const radioApplied = applyRadioRules(mod, radioValue, prevChildren)[
              i
            ];

            // Mantener el check manual si estaba marcado antes y no lo controla el radio
            if (
              ![
                "own",
                "onlyassign",
                "notes_own",
                "notes_all",
                "alerts_own",
                "alerts_all",
              ].some((p) => perm.includes(p)) &&
              prevChildren[i] !== undefined
            ) {
              return prevChildren[i];
            }

            return radioApplied;
          });

          newState[mod.id] = {
            parentChecked: childrenChecked.every(Boolean),
            childrenChecked,
          };
        });
      return newState;
    });
  }, [radioValue, role]);

  // --- FUNCION APPLYRADIORULES ---
  const applyRadioRules = (mod, access, previous) => {
    return mod.permissions.map((p, i) => {
      // solo aplica radio si no hay cambio manual (undefined)
      if (previous?.[i] !== undefined) return previous[i];

      if (access === "1") {
        if (p.includes("own") || p === "onlyassign") return false;
        return true;
      } else if (access === "2") {
        if (["onlyassign", "view", "notes_own", "alerts_own"].includes(p))
          return true;
        return false;
      } else if (access === "4") {
        if (["view", "notes_own", "alerts_own"].includes(p)) return true;
        return false;
      }

      return false;
    });
  };

  /* ======================================================
     HANDLERS DE CHECKBOX
  ===================================================== */
  const handleChangeParent = (moduleId) => {
    setCheckedState((prev) => {
      if (!prev[moduleId]) return prev;

      const mod = Object.values(MODULE_DEFINITIONS)
        .flat()
        .find((m) => m.id === moduleId);
      if (!mod) return prev;

      const value = !prev[moduleId].parentChecked;
      const childrenChecked = mod.permissions.map((perm, i) => {
        // si ya habí­a un cambio manual, mantenlo
        const manual = prev[moduleId].childrenChecked[i];
        return manual !== undefined ? manual : value;
      });

      return {
        ...prev,
        [moduleId]: {
          parentChecked: childrenChecked.every(Boolean),
          childrenChecked,
        },
      };
    });
  };

  const handleChangeChild = (moduleId, index) => {
    setCheckedState((prev) => {
      if (!prev[moduleId]) return prev;

      const mod = Object.values(MODULE_DEFINITIONS)
        .flat()
        .find((m) => m.id === moduleId);
      if (!mod) return prev;

      // Copiar children y asegurar todos los í­ndices
      const children = mod.permissions.map(
        (perm, i) => prev[moduleId]?.childrenChecked[i] ?? false,
      );

      const perm = mod.permissions[index];
      const newValue = !children[index];

      // Validación exclusivas
      let blocked = false;
      Object.entries(EXCLUSIVE_PERMISSION_GROUPS).forEach(
        ([groupKey, exclusivePerms]) => {
          if (exclusivePerms.includes(perm) && newValue) {
            const actionPerms = ACTION_PERMISSION_GROUPS[groupKey] || [];
            const hasAnyActionSelected = mod.permissions.some(
              (p, i) => actionPerms.includes(p) && children[i],
            );
            if (!hasAnyActionSelected) {
              Swal.fire({
                icon: "warning",
                title: "Selecciona una acción primero",
                text: "Antes de elegir si aplica a todas o solo propias, debes seleccionar una acción.",
                confirmButtonColor: "#f8ac59",
              });
              blocked = true;
            }
          }
        },
      );
      if (blocked) return prev;

      children[index] = newValue;

      // Exclusivas: solo una activa
      Object.values(EXCLUSIVE_PERMISSION_GROUPS).forEach((group) => {
        if (group.includes(perm) && newValue) {
          group.forEach((p) => {
            if (p !== perm) {
              const otherIndex = mod.permissions.indexOf(p);
              if (otherIndex !== -1) children[otherIndex] = false;
            }
          });
        }
      });

      // Si desmarco, desmarco tambíon acción asociada
      if (
        Object.values(EXCLUSIVE_PERMISSION_GROUPS).some((group) =>
          group.includes(perm),
        ) &&
        !newValue
      ) {
        const actionPerms =
          ACTION_PERMISSION_GROUPS[
            Object.keys(EXCLUSIVE_PERMISSION_GROUPS).find((key) =>
              EXCLUSIVE_PERMISSION_GROUPS[key].includes(perm),
            )
          ] || [];
        mod.permissions.forEach((p, i) => {
          if (actionPerms.includes(p)) children[i] = false;
        });
      }

      return {
        ...prev,
        [moduleId]: {
          childrenChecked: children,
          parentChecked: children.every(Boolean),
        },
      };
    });
  };

  /* ======================================================
     VALIDACIONES
  ===================================================== */
  const validateOwnAllBeforeSave = () => {
    for (const mod of Object.values(MODULE_DEFINITIONS).flat()) {
      const state = checkedState[mod.id];
      if (!state) continue;
      const children = state.childrenChecked;
      for (const [groupKey, actionPerms] of Object.entries(
        ACTION_PERMISSION_GROUPS,
      )) {
        const exclusivePerms = EXCLUSIVE_PERMISSION_GROUPS[groupKey];
        const actionSelected = mod.permissions.some(
          (p, i) => actionPerms.includes(p) && children[i],
        );
        if (!actionSelected) continue;
        const hasOwnOrAll = mod.permissions.some(
          (p, i) => exclusivePerms.includes(p) && children[i],
        );
        if (!hasOwnOrAll) return { module: mod.id, group: groupKey };
      }
    }
    return null;
  };

  /* ======================================================
     GUARDAR
  ===================================================== */
  const handleSaveEdit = async () => {
    const validationError = validateOwnAllBeforeSave();
    if (validationError) {
      Swal.fire({
        icon: "warning",
        title: "Permisos incompletos",
        html: `En el módulo <b>${validationError.module}</b><br/>Has seleccionado <b>Eliminar</b> pero no indicaste si aplica a <b>Propias</b> o <b>Todas</b>.`,
        confirmButtonColor: "#f8ac59",
      });
      return;
    }

    const config = { access: radioValue };
    Object.values(MODULE_DEFINITIONS)
      .flat()
      .forEach((mod) => {
        config[mod.backendKey] = {};
        mod.permissions.forEach((perm, i) => {
          config[mod.backendKey][perm] =
            (checkedState[mod.id]?.childrenChecked[i] ?? false) ? 1 : 0;
        });
      });

    const confirm = await Swal.fire({
      icon: "question",
      title: "Confirmar cambios",
      text: "¿Deseas guardar los cambios?",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    });
    if (!confirm.isConfirmed) return;

    try {
      Swal.fire({
        title: "Guardando cambios...",
        html: "Actualizando configuración del rol",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await api.post(`${process.env.REACT_APP_API_URL}/roles/update`, {
        id: rolId,
        rol: rolData.rol,
        user_level: rolData.user_level,
        config,
      });

      Swal.fire({
        icon: "success",
        title: "Cambios guardados",
        text: "El rol fue actualizado correctamente.",
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Perfecto",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "No se pudo actualizar el rol. Intenta nuevamente.",
        confirmButtonColor: "#d33",
      });
    }
  };

  /* ======================================================
     ACCIONES SOBRE ROL
  ===================================================== */
  const handleDeleteRole = async () => {
    const confirm = await Swal.fire({
      icon: "warning",
      title: "Eliminar rol",
      text: "¿Seguro que deseas eliminar este rol?",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d33",
    });
    if (!confirm.isConfirmed) return;
    try {
      await api.post(`${process.env.REACT_APP_API_URL}/roles/delete`, {
        id: rolId,
      });
      goTable("roles", "Roles");
    } catch {
      Swal.fire("Error", "No se pudo eliminar", "error");
    }
  };

  const handleDuplicateRole = async () => {
    try {
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/roles/duplicate`,
        { id: rolId },
      );
      Swal.fire(
        "Duplicado",
        `Rol duplicado con í©xito: ${res.data.newRoleName}`,
        "success",
      ).then(() => goTable("roles", "Roles"));
    } catch {
      Swal.fire("Error", "No se pudo duplicar", "error");
    }
  };

  /* ======================================================
     RENDER DE PERMISOS
  ===================================================== */
  const renderPermissions = (mod) => {
    const groups =
      mod.id === "Expedientes"
        ? EXPEDIENTES_GROUPS
        : mod.id === "Clientes"
          ? CLIENTES_GROUPS
          : mod.id === "Contactos"
            ? CONTACTS_GROUPS
            : [{ title: "", permissions: mod.permissions }];

    return groups.map((group) => (
      <Grid item xs={12} key={group.title}>
        {group.title && (
          <Typography
            variant="caption"
            fontWeight="bold"
            sx={{
              display: "block",
              mb: 0.5,
              mt: 1,
              pl: 1,
              color: "text.secondary",
              borderLeft: "3px solid #1976d2",
            }}>
            {group.title}
          </Typography>
        )}
        <Grid container spacing={0.5} sx={{ pl: 1 }}>
          {group.permissions
            .filter((perm) =>
              perm.toLowerCase().includes(searchPermission.toLowerCase()),
            )
            .map((perm) => {
              const permIndex = mod.permissions.indexOf(perm);
              if (permIndex === -1) return null;
              return (
                <Grid item xs={6} sm={4} md={2} key={perm}>
                  <FormControlLabel
                    sx={{
                      m: 0,
                      "& .MuiFormControlLabel-label": { fontSize: 12 },
                    }}
                    control={
                      <Checkbox
                        size="small"
                        checked={
                          checkedState[mod.id]?.childrenChecked[permIndex] ||
                          false
                        }
                        disabled={isCheckboxDisabled(
                          checkedState[mod.id]?.childrenChecked[permIndex] ||
                            false,
                        )}
                        onChange={() => handleChangeChild(mod.id, permIndex)}
                      />
                    }
                    label={PERMISSION_LABELS[perm]}
                  />
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    ));
  };

  const renderSection = (title, modules) => (
    <>
      <Grid item xs={12}>
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          sx={{ mb: 1, mt: 2, color: "text.secondary" }}>
          {title}
        </Typography>
      </Grid>
      {modules.map((mod) => (
        <Grid item xs={12} key={mod.id}>
          <Paper
            variant="outlined"
            sx={{ p: 1.5, borderRadius: 2, backgroundColor: "#fafafa" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                px: 1,
                py: 0.5,
                borderRadius: 1,
                backgroundColor: "#f0f2f5",
              }}>
              <Checkbox
                size="small"
                checked={checkedState[mod.id]?.parentChecked || false}
                onChange={() => handleChangeParent(mod.id)}
              />
              <Typography fontWeight="bold" fontSize={14}>
                {mod.id}
              </Typography>
              <TextField
                size="small"
                placeholder="Buscar permiso"
                value={searchPermission}
                onChange={(e) => setSearchPermission(e.target.value)}
                sx={{ ml: 2 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton size="small">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Divider sx={{ my: 1 }} />
            <Grid container spacing={0.5}>
              {renderPermissions(mod)}
            </Grid>
          </Paper>
        </Grid>
      ))}
    </>
  );

  /* ======================================================
     RENDER
  ===================================================== */
  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Roles" subTitle="Editar" />
      <Fade in={flag} timeout={800}>
        <Paper sx={{ p: 4 }}>
          <Grid container spacing={2}>
            {/* DATOS DEL ROL */}
            <Grid item xs={12}>
              <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography fontWeight="bold">Datos del rol</Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Nombre del rol"
                      value={rolData.rol}
                      disabled={isSuperAdmin}
                      onChange={(e) =>
                        setRolData({ ...rolData, rol: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      label="Nivel"
                      value={rolData.user_level}
                      disabled={isSuperAdmin}
                      onChange={(e) =>
                        setRolData({ ...rolData, user_level: e.target.value })
                      }
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* NIVEL DE ACCESO */}
            <Grid item xs={12}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography fontWeight="bold">Nivel de acceso</Typography>
                <Divider sx={{ mb: 2 }} />
                <FormControl>
                  <RadioGroup
                    row
                    value={radioValue}
                    onChange={(e) => setRadioValue(e.target.value)}>
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Todos"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label="Empresa"
                    />
                    <FormControlLabel
                      value="4"
                      control={<Radio />}
                      label="Propios"
                    />
                  </RadioGroup>
                </FormControl>
              </Paper>
            </Grid>

            {/* PERMISOS */}
            {renderSection("Módulos principales", MODULE_DEFINITIONS.core)}
            {renderSection("Configuración", MODULE_DEFINITIONS.configuracion)}
            {renderSection("Otros", MODULE_DEFINITIONS.otros)}

            {/* ACCIONES */}
            <Grid item xs={12}>
              <ButtonGroup fullWidth size="large">
                <Button color="success" onClick={handleSaveEdit}>
                  Guardar
                </Button>
                {/* <Button color="error" onClick={handleDeleteRole}>
                  Eliminar
                </Button> */}
                {/* <Button color="info" onClick={handleDuplicateRole}>
                  Duplicar
                </Button> */}
                <NavButton
                  to={buildTableUrl("roles")}
                  onClick={() => goTable("roles", "Roles")}>
                  Tabla
                </NavButton>
                <Button onClick={goPanel}>Inicio</Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Paper>
      </Fade>
    </div>
  );
};

export default Editar;
